import { render, staticRenderFns } from "./TopAdviceDataWrapper.vue?vue&type=template&id=7d3f08d0&"
import script from "./TopAdviceDataWrapper.vue?vue&type=script&lang=js&"
export * from "./TopAdviceDataWrapper.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./TopAdviceDataWrapper.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "04408281"
  
)

export default component.exports